module.exports = __webpack_public_path__ + "img/consult-title.cf140672.png";